Alerts = require 'views/lib/alerts'
Auth = require 'db/auth'
Controller = require 'controller'
getExperiment = require 'lib/experiments/simple-test'
template = require 'views/templates/create_first_board'
View = require 'view'
Util = require 'lib/util'
_ = require 'underscore'

module.exports = class CreateFirstBoardView extends View
  className: 'first-board-container'
  tagName: 'form'
  events:
    'click .js-submit': 'onSubmit'
    'keyup .js-board-name': 'onKeyup'
    'click .js-cancel': 'onCancel'

  initialize: ->
    @listenTo @model.boardList, 'update reset', @handleNewBoard

  render: ->
    @$el.html(template({}))
    @

  onKeyup: (e) ->
    boardName = @$(e.target).val()?.trim()

    @$('.js-board-name-display')
      .text(boardName)
      .toggleClass('is-active', boardName?.length > 0)

    @$('.js-submit').toggleClass('is-active', boardName?.length > 0)

  onSubmit: (e) ->
    Util.stop(e)
    name = @$('.js-board-name').val()?.trim()
    if !name? || name.length == 0
      @$('.js-board-name').focus()
      return

    # Data that we'll use in the body of the POST to create the board
    initialData = { name }

    # Data that we're going to send in the create request; not all of the
    # fields will be board attributes
    requestData = _.extend({
      prefs_permissionLevel: 'private'
      prefs_selfJoin: true
      prefs_background: 'lime'
      defaultLists: true
    }, initialData)

    newBoard = Auth.me().boardList.create initialData, {
      requestData: requestData
      success: (board) =>

        # this fixes an issue with idBoards not being updated at the time that
        # the board gets rendered and the client thinking the member is not on
        # the board
        if board.id !in (currentBoards = Auth.me().get('idBoards'))
          Auth.me().set('idBoards', currentBoards.concat(board.id))

        # We have to wait until we get the board id back before we can
        # display the board
        Controller.displayBoard({
          idBoard: board.id
          openListComposer: false
          openCardComposerInFirstList: true
        }).done()

        return
      error: =>
        Alerts.flash('could not create board', 'error', 'create error')
    }

  onCancel: (e) ->
    Util.stop(e)

    @model.dismiss('create-first-board', ->
      Controller.navigate '/', { trigger: true }
    )

  handleNewBoard: ->
    Controller.navigate '/', { trigger: true }



// WEBPACK FOOTER //
// ./app/scripts/views/board/create-first-board-view.coffee